import React from 'react';

const YouTube = () => {
   return (
      <a href="https://www.youtube.com/user/OLXInTv">
         <svg
            width="48px"
            height="48px"
            viewBox="0 0 1024 1024"
            data-aut-id="icon"
            fillRule="evenodd"
         >
            <path
               className="rui-4K4Y7"
               d="M512 85.321c235.648 0 426.667 191.019 426.667 426.667s-191.019 426.667-426.667 426.667c-235.648 0-426.667-191.019-426.667-426.667s191.019-426.667 426.667-426.667zM512 150.601c-199.595 0-361.429 161.792-361.429 361.387 0 199.637 161.835 361.429 361.429 361.429s361.429-161.792 361.429-361.429c0-199.595-161.835-361.387-361.429-361.387zM382.605 321.86l311.125 190.123-311.125 190.165v-380.288z"
            />
         </svg>
      </a>
   );
};

export default YouTube;
